module.exports = __webpack_public_path__ + "img/mobile-avatar.1517e7a0.svg";